import { fromLonLat } from "ol/proj";
import { Tile as TileLayer, Vector as VectorLayer } from "ol/layer";
import { XYZ, BingMaps } from "ol/source";
import { Circle, Fill, Stroke, Style } from "ol/style";
import { Vector as VectorSource } from "ol/source";
import Map from "ol/Map";
import { defaults } from "ol/interaction";
import View from "ol/View";

export const managementMapsMixin = {
  data() {
    return {
      map: null,
      mapView: null,
      roadMap: null,
      vectorSource: null,
      vectorLayer: null,
      defaultStyle: null,
      isAerial: false,
      aerialMapLayer: null
    };
  },

  methods: {
    createDefaultStyle() {
      let defaultStroke = new Stroke({
        color: "rgba(41, 189, 240, 1)",
        width: 1.25
      });

      let defaultFill = new Fill({
        color: "rgba(255,255,255,0.4)"
      });

      this.defaultStyle = new Style({
        image: new Circle({
          fill: defaultFill,
          stroke: defaultStroke,
          radius: 5
        }),
        fill: defaultFill,
        stroke: defaultStroke
      });
    },

    createMap() {
      this.getRoadMap();
      this.createVectorLayer();
      this.createMapView();

      this.map = new Map({
        target: "map",
        layers: [this.roadMap, this.vectorLayer],
        interactions: defaults({ doubleClickZoom: false }),
        view: this.mapView
      });
    },

    getRoadMap() {
      this.roadMap = new TileLayer({
        visible: true,
        source: new XYZ({
          url: "https://{a-c}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}.png?key=cb1_25c8_1_e605659edefdab50e8570e14"
        })
      });
    },

    createVectorLayer() {
      this.vectorSource = new VectorSource({ wrapX: false });
      this.vectorLayer = new VectorLayer({
        source: this.vectorSource,
        style: this.defaultStyle
      });
    },

    createMapView() {
      this.mapView = new View({
        center: fromLonLat([0, 45]),
        zoom: 4,
        minZoom: 3,
        maxZoom: 25
      });
    },

    changeViewType() {
      this.roadMap.setVisible(this.isAerial);
      this.aerialMapLayer.setVisible(!this.isAerial);
      this.isAerial = !this.isAerial;
      this.map.updateSize();
    },

    createAerialMapLayer() {
      this.aerialMapLayer = new TileLayer({
        visible: false,
        source: new BingMaps({
          key:
            "AtUEuM0GKaXtnijUSNcuIcmQItWcpMstzANuR3ONhBKeY3LsFPqLFznuwXMHP2kb",
          imagerySet: "Aerial",
          culture: "en-EN",
          labelOverlay: "visible",
          maxZoom: 19
        })
      });
      this.map.addLayer(this.aerialMapLayer);
    },

    getFeatureStyle(type, highlightStyle) {
      switch (type) {
        case "Point":
          return new Style({
            image: new Circle({
              radius: highlightStyle.point.radius,
              fill: new Fill({
                color: highlightStyle.point.fillColor,
                zIndex: 1,
              }),
            }),
          });
        case "Polygon":
        case "MultiPolygon":
          return new Style({
            stroke: new Stroke({
              color: highlightStyle.polygon.strokeColor,
              width: highlightStyle.polygon.strokeWidth,
              zIndex: 1,
            }),
            fill: new Fill({
              color: highlightStyle.polygon.fillColor,
              zIndex: 1,
            }),
          });
        case "LineString":
        case "MultiLineString":
          return [
            new Style({
              stroke: new Stroke({
                color: highlightStyle.line.strokeColor,
                width: highlightStyle.line.strokeWidth,
                zIndex: 1,
              }),
            }),
          ];
      }
    },
  }
};



// WEBPACK FOOTER //
// ./src/mixins/management/managementMapsMixin.js